import * as React from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { Autocomplete, Button, CircularProgress, FormControl, Grid, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import apiService from '../../../utlis/apiService';
import DownloadIcon from '@mui/icons-material/Download';
import { apiUrl } from '../../../config';
import { generateYearRange, getMode, getQualification } from '../../../utlis/commonFunction';
import { useUser } from '../../../context/userContext';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers-pro';
import dayjs from 'dayjs';

export default function AdmissionDropReport() {
    const { permissions } = useUser();
    const [data, setData] = React.useState([]);
    const [filterData, setFilterData] = React.useState({
        dateFrom: '',
        dateTo: '',
        year: '',
        course: '',
        courseStatus: '',
        category: '',
    });

    const years = generateYearRange();

    const [courses, setCourse] = React.useState([]);
    const [categories, setCategories] = React.useState([]);
    const [totalResults, setTotalResults] = React.useState(0);

    const [paginationModel, setPaginationModel] = React.useState({
        pageSize: 50,
        page: 0,
    });
    const [loading, setLoading] = React.useState(false);

    const pageOption = [10, 25, 50, 100];

    React.useEffect(()=> {
        getStudentsData();
    },[filterData, paginationModel]);

    React.useEffect(()=> {
        getData();
    },[]);

    React.useEffect(()=> {
        if(filterData.course || filterData.courseStatus || filterData.year)
            getCategory();
    },[filterData.course, filterData.courseStatus, filterData.year]);

    const getData = async () => {
        try {
            const courseResponse = await apiService.get('/course/list');

            setCourse(courseResponse?.data?.course);
        } catch (error) {
            console.error(error);
        }
    }

    const getCategory = async () => {
        try {
            const categoryResponse = await apiService.post(`/level/list/categoryByCourse`, {courseId: filterData.course, statusType: filterData.courseStatus, year: filterData.year});
            setCategories(categoryResponse?.data?.categories);
        } catch (error) {
            console.error(error);
        }
    }

    const getStudentsData = async () => {
        setLoading(true);
        try {
            const response = await apiService.get('/report/admission-drop', {
                params: {
                    ...filterData,
                    page: paginationModel.page,
                    pageSize: paginationModel.pageSize,
                }
            });

            setData(response?.data?.report);
            setTotalResults(response?.data?.totalResults);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleChangeSubmit = (e, value, name) => {
        setFilterData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleChange = (name, value) => {
        setFilterData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const exportReport = async () => {
        try {
            const response = await apiService.get('/export/report/admission-drop', {
                params: {
                    ...filterData,
                },
            });

            if(response?.data?.status === 'success') {
                
                window.open(`${apiUrl}${response?.data?.path}`, '_blank');
            }
        }
        catch (error) {
            console.error(error);
        }
    }

    const getColumn = () => {
        const columns = [
            { field: 'name', headerName: 'Name', flex: 1},
            { field: 'phone', headerName: 'Phone', flex: 1},
            { field: 'year', headerName: 'Academic Year', flex: 1},
            { field: 'branch', headerName: 'Branch', flex: 1},
            { field: 'course', headerName: 'Course', flex: 1},
            { field: 'statusType', headerName: 'Course Status', flex: 1},
            { field: 'category', headerName: 'Category', flex: 1},
            { field: 'lostAmount', headerName: 'Amount Lost', flex: 1},
            // { field: 'approvedBy', headerName: 'Approved By', flex: 1},
        ];

        return columns;
    }

    const columns = getColumn();

    return (
        <div style={{ height: '75vh', width: '100%' }}>
            <Typography variant="h4" gutterBottom>
                ADMISSION DROP REPORT
            </Typography>
            <Grid container spacing={2} alignItems="center" sx={{ marginBottom: 2 }}>
                <Grid item xs={3}>
                    <Autocomplete
                        disablePortal
                        id="combo-box-year"
                        name="year"
                        options={years}
                        style={{ marginTop: 15 }}
                        getOptionLabel={(option) => option}
                        value={filterData.year || null}
                        onChange={(e, value) => handleChangeSubmit(e, value, 'year')}
                        renderInput={(params) => <TextField {...params} label="Academic Year" size='small' />}
                    />
                </Grid>
                <Grid item xs={3}>
                    <Autocomplete
                        disablePortal
                        id="combo-box-course"
                        name="course"
                        options={courses}
                        style={{ marginTop: 15 }}
                        getOptionLabel={(option) => option.name}
                        value={courses?.find((option) => option._id === filterData.course) || null}
                        onChange={(e, value) => handleChangeSubmit(e, value?._id, 'course')}
                        renderInput={(params) => <TextField {...params} label="Course" size='small' />}
                    />
                </Grid>
                <Grid item xs={3}>
                    <FormControl fullWidth sx={{ marginTop: '15px' }} size="small">
                        <InputLabel id="CourseStatus">Course Status</InputLabel>
                        <Select
                            label="Course Status"
                            value={filterData.courseStatus}
                            onChange={(e) => handleChange('courseStatus', e.target.value)}
                            fullWidth
                            name="courseStatus"
                            size='small'
                        >
                            <MenuItem value="">All</MenuItem>
                            <MenuItem value="Prime">Prime</MenuItem>
                            <MenuItem value="Prime Plus">Prime Plus</MenuItem>
                            <MenuItem value="Level">Level</MenuItem>
                            <MenuItem value="Paper">Paper</MenuItem>
                            <MenuItem value="Other">Other</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={3}>
                    <Autocomplete
                        disablePortal
                        id="combo-box-category"
                        name="category"
                        options={categories}
                        style={{ marginTop: 15 }}
                        getOptionLabel={(option) => option.name}
                        value={categories.find((option) => option._id === filterData.category) || null}
                        onChange={(e, value) => handleChangeSubmit(e, value?._id, 'category')}
                        renderInput={(params) => <TextField {...params} label="Category" size='small' />}
                    />
                </Grid>
                {/* <Grid item xs={2}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} locale="en">
                        <FormControl className='gap-2 mb-8' fullWidth size='small'>
                            <MobileDatePicker
                                value={filterData.dateFrom ? dayjs(filterData.dateFrom) : null}
                                onChange={(date) => handleChange('dateFrom', date)}
                                sx={{ marginTop: 2 }}
                                format="DD/MM/YYYY"
                                label="Date From"
                                slotProps={{
                                    actionBar: {
                                      actions: ['clear', 'cancel', 'accept'],
                                    },
                                    textField: { size: 'small' }
                                }}
                            />
                        </FormControl>
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={2}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} locale="en">
                        <FormControl className='gap-2 mb-8' fullWidth size='small'>
                            <MobileDatePicker
                                value={filterData.dateTo ? dayjs(filterData.dateTo) : null}
                                onChange={(date) => handleChange('dateTo', date)}
                                sx={{ marginTop: 2 }}
                                format="DD/MM/YYYY"
                                label="Date To"
                                slotProps={{
                                    actionBar: {
                                      actions: ['clear', 'cancel', 'accept'],
                                    },
                                    textField: { size: 'small' }
                                }}
                            />
                        </FormControl>
                    </LocalizationProvider>
                </Grid> */}
            </Grid>
            
            <Grid container spacing={2} alignItems="center" sx={{ marginBottom: 3 }}>
                <Grid item xs={4}>
                </Grid>
                <Grid item xs={8}>
                    {permissions.includes('exportAdmissionReport') && (
                        <Button variant="outlined" size='small' sx={{ float: 'right' }} title="Export" onClick={exportReport}><DownloadIcon /></Button>
                    )}
                </Grid>
            </Grid>
            {loading ? (
                <div style={{ textAlign: 'center' }}>
                    <CircularProgress style={{ margin: 'auto' }} />
                </div>

            ) : (
                <DataGridPro
                    getRowId={(row) => row._id}
                    rows={data}
                    disableDensitySelector
                    columns={columns}
                    pagination
                    paginationModel={paginationModel}
                    rowCount={totalResults}
                    paginationMode="server"
                    onPaginationModelChange={setPaginationModel}
                    rowsPerPageOptions={pageOption}
                />
            )}
        </div>
    );
}
